import axios from 'axios';

export default {
  get: params => axios.get('/api/v1/avg/shift-positions', { params }),
  create: params => axios.post('/api/v1/avg/shift-positions', params),
  update: params => axios.put(`/api/v1/avg/shift-positions/${params.id}`, params),
  remove: params => axios.delete('/api/v1/avg/shift-positions', { params })
};
